import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import $ from 'jquery';
import { Helmet } from 'react-helmet';
import styles from './styles.css';

const { initializeGlobalSiteTag } = require('../../../lib/global-site-tag').default;

class LoggedOutLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  static defaultProps = {
  }

  componentDidMount = () => {
    initializeGlobalSiteTag();
    $(global.window.document.body).addClass(styles.loggedOutBody);
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        <Helmet>
          <link rel="shortcut icon" href="/images/favicon.ico" type="image/x-icon" />
        </Helmet>
        <div className={styles.mainBox}>
          <div className={styles.mainFormContainer}>
            <div className={styles.mainScreen}>
              {children}
            </div>
          </div>
        </div>
        <ToastContainer
          position="bottom-center"
          hideProgressBar
          autoClose={5000}
          closeButton={false}
          closeOnClick
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}

export default LoggedOutLayout;
